module.exports = {
  title: 'Record Button Animation with Skia 🎤',
  author: 'Enzo Manuel Mangano',
  date: '2024-05-15',
  slug: 'record-button',
  tags: ['skia'],
};
